// File: src/services/catalogService.js
import { getFirestore, doc, getDoc, setDoc, updateDoc, serverTimestamp } from "firebase/firestore";

const CATALOG_LIMIT = 500;

/**
 * Updates /platform/songCatalog when a song is uploaded from the client.
 * Consumes 1 Read + 1 Write on upload, keeping recommendation read costs at ~2 reads.
 */
export const addSongToPlatformCatalog = async (songData) => {
  const db = getFirestore();
  const catalogRef = doc(db, "platform", "songCatalog");

  try {
    const catalogSnap = await getDoc(catalogRef);

    const newEntry = {
      id: songData.id,
      artistId: songData.artistId || "unknown",
      randomSeed: songData.randomSeed || Math.random(),
    };

    if (!catalogSnap.exists()) {
      // First-time initialization of the catalog document
      await setDoc(catalogRef, {
        recentSongs: [newEntry],
        songCount: 1,
        lastUpdated: serverTimestamp(),
      });
      console.log("✅ Initialized /platform/songCatalog with first track.");
      return;
    }

    const currentCatalog = catalogSnap.data().recentSongs || [];

    // Prepend new song to top of list & truncate to 500 items
    const updatedCatalog = [
      newEntry, 
      ...currentCatalog.filter((s) => s.id !== songData.id)
    ].slice(0, CATALOG_LIMIT);

    await updateDoc(catalogRef, {
      recentSongs: updatedCatalog,
      songCount: updatedCatalog.length,
      lastUpdated: serverTimestamp(),
    });

    console.log(`✅ Prepended song ${songData.id} to /platform/songCatalog`);
  } catch (error) {
    console.error("⚠️ Error updating /platform/songCatalog during upload:", error);
    // Non-blocking: We catch errors so failed catalog updates do not break the user upload toast
  }
};